import React, { useEffect, useState } from "react";
import '../../../CSS/Materiales.css'
import {BsFiletypePdf, BsPlus} from "react-icons/bs";
import {getPermission} from '../../../Conexiones/Conexion'
import { useNavigate } from "react-router";
import moment from "moment/moment";
import { calibriBold,calibriRegular } from "../../../Fonts/font";
import autoTable from 'jspdf-autotable'
import { jsPDF } from "jspdf";
import watermark from "../../../Img/watermark.png"
import { Button, CloseButton, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { PropagateLoader } from "react-spinners";
import { getApi, postApi } from "../../../Conexiones/Models";
import { closeAlert, errorMessage, errorToast, successToast, warningToast } from "../../../Utils/AlertMessage";
import { FaArrowLeftLong } from "react-icons/fa6";
import Loading from '../../../Utils/Loading';

function GastosAdicionalesObra(){
    const navigate = useNavigate();
    const obraId = parseInt(sessionStorage.getItem("obra"));
    const [gastos, setGastos] = useState([]);
    const [tablaGastos, setTablaGastos] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [totalAdi, setTotalAdi] = useState(0);
    const [direccion,setDireccion] = useState('');
    const [fechaSelect, setFecha] = useState();
    const [typePdf, setTypePdf] = useState('');
    const [obra,setObra] = useState('');
    const [cliente,setCliente] = useState('');
    const [isSaving, setSaving] = useState(false);
    const [isLoading,setIsLoading]=useState(false);
    //AGREGAR GASTO ADICIONAL
    const [concepto,setConcepto] = useState();
    const [cantidad,setCantidad] = useState();
    const [precio,setPrecio] = useState();
    const [fecha,setFechaAd] = useState();
    const [adicionales,setAdicionales] = useState([]);
    const [unidades,setUnidades]=useState([]);
    const [idUnidad,setidUnidad]=useState('');
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;

    useEffect( ()=>{
        const getGastos = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,28);
            if(permiso){
                const endpoint = 'gastos-adicionales-obra-ini/'+obraId;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setGastos(res.data[0].gastos);
                        setTablaGastos(res.data[0].gastos);
                        setTotalAdi(res.data[0].total);
                        setObra(res.data[0].obra);
                        setDireccion(res.data[0].direccion);
                        setCliente(res.data[0].cliente);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        }
        getGastos()
    },[navigate,idUsuario,obraId])

    const getAdicionales = async () =>{
        const endpoint = 'adicionales/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setAdicionales(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const [showGasAdic, setShowGasAdic] = useState(false);
    const handleCloseAdicional = () => {
        closeAlert();
        setShowGasAdic(false);
        setidUnidad('');
        setFechaAd('');
        setPrecio('');
        setCantidad('');
        setConcepto('');
    }
    const handleShowAdicional = async () =>{
        await getAdicionales();
        await getUnidades();
        setShowGasAdic(true);
    }

    const handleSelectChange = (event) =>{
        setidUnidad(event.value)
    }
    //MODAL DESCARGANDO
    const [showDescargar, setShowDescargar] = useState(false);
    const handleCloseDescarg = () => {
        setShowDescargar(false);
    }
    const handleShowDescarg = () =>{
        setShowDescargar(true);
    }
    
    const getGastos = async () =>{
        const permiso = await getPermission(idUsuario,28);
        if(permiso){
            const endpoint = 'gastos-adicionales-obra-ini/'+obraId;
            const res = await getApi(endpoint);
            if(res.status === 1){
                if(res.data.length !== undefined){
                    setGastos(res.data[0].gastos);
                    setTablaGastos(res.data[0].gastos);
                    setTotalAdi(res.data[0].total);
                }else{
                    errorMessage(res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }else{
            navigate('/inicio')
        }
    }

    const getUnidades = async () =>{
        const endpoint = 'unidad/';
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setUnidades(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    var registros = []
    var inicio='';
    var fin='';
    var totalSemana='';

    //MODAL PDF
    const [showPdf, setShowPdf] = useState(false);
    const handleClosePdf = () => {
        setShowPdf(false);
        setFecha('');
        setTypePdf('')
        registros=[]
    }
    const handleShowPdf = () =>{
        setShowPdf(true);
    } 

    const tipoPdf = e => {
        setTypePdf(e.target.value)
    }
    
    function formato(numero){
        var num = Number.parseFloat(numero).toFixed(2)
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }
    
    const adiTotal = formato(totalAdi)

    const regresar = () => {
        navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras/')
    }
   
    const buscar = e => {
        setBusqueda(e.target.value)
        filtrar(e.target.value)
    }

    const filtrar = (texto) => {
        var resBusqueda = tablaGastos.filter((elemento)=> {
            if (elemento.nombreAdicional.toString().toLowerCase().includes(texto.toLowerCase())){  
                return elemento; 
            }
            return resBusqueda
        })
        setGastos(resBusqueda)
    }

    const confirmar = async () =>{
        warningToast('¿ESTAS SEGURO DE REGISTRAR ESTE GASTO?','',true)
        .then(async (result) => {        
            if (result.isConfirmed) {
                setSaving(true);
                const idAd = parseInt(concepto);
                const cant = parseFloat(cantidad);
                const price = parseFloat(precio);
                const endpoint = 'gastos-adicionales-obra/';
                const data = {idObra:obraId, idAdicional:idAd, unidad:idUnidad, cantidad:cant, precio:price, fecha:fecha};
                const res = await postApi(endpoint,data);
                if(res.status === 1){
                    if(res.data.message==="SE GUARDÓ EL REGISTRO CORRECTAMENTE"){
                        handleCloseAdicional();
                        getGastos();
                        successToast("AGREGADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
                setSaving(false);
            }
        })
    }

    const validar = async () =>{
        warningToast('CAMPOS VACIOS','RELLENE LOS CAMPOS OBLIGATORIOS',false);
    }

    const getRegistros = async (fechaIngresada) =>{
        if(typePdf===''){
            warningToast('DEBE SELECCIONAR UNA OPCIÓN');
        }else{
            handleShowDescarg();
            if(typePdf==="semana"){
                if(fechaIngresada===undefined || fechaIngresada===''){
                    warningToast('DEBE INGRESAR UNA FECHA');
                }else{
                    handleClosePdf();
                    const endpoint = 'gastos-SemanAdicionales-pdf/'+obraId+'/'+fechaIngresada;
                    const res = await getApi(endpoint);
                    if(res.status === 1){
                        if(res.data.length !== undefined){
                            registros=res.data[0].lista
                            inicio=res.data[0].inicio
                            fin=res.data[0].fin
                            totalSemana=res.data[0].totalSemana
                        }else{
                            errorMessage(res.data.message);
                        }
                    }else if(res.status === 210){
                        navigate('/');
                    }else{
                        errorMessage(res.message);
                    }
                    if(registros.length===0){
                        warningToast('NO EXISTEN REGISTROS DE LA FECHA SELECCIONADA');
                       
                    }else{
                        descargar(registros,inicio,fin,totalSemana);
                    }
                }
            }else{
                //PDF GENERAL
                handleClosePdf();
                const endpoint = 'gastos-GeneralAadicionales-pdf/'+obraId;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        registros=res.data[0].lista
                        totalSemana=res.data[0].totalSemana
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
                descargar(registros,inicio,fin,totalSemana);
            }
            handleCloseDescarg();
        }
    }
    const getFecha = () =>{
        const date= moment (new Date());
        return(date.tz('America/Mexico_City').format('YYYY-MM-DD'))
    }
    const descargar = (lista,ini,fin,totalSemana) => {
        handleShowDescarg();
        switch (typePdf) {
            case 'semana':
                //setRegistros([])
                //getRegistros(fechaSelect);
                //console.log(registros)
                //registros.length = 0 //limpiar lista
                var date = moment( new Date());
                const fecha = date.tz('America/Mexico_City').format('DD/MM/YYYY')
                const fechaDescarga = moment(fin).format('DD-MM-YYYY')
                //const fecha2 = date.tz('America/Mexico_City').format('DDMMYY')
                //console.log(fecha)
                var doc = new jsPDF({format: 'letter',orientation:"portrait"});
                var company_logo = {
                    w: 30,
                    h: 20
                };

                var startY=0;
                //IMAGEN
                var imgData ="https://www.app-system.rosmocoin.com/rosmo-img/rosmo-logo-v2.png"
                doc.addImage(imgData,'JPEG',10,25,company_logo.w,company_logo.h);
                //TITULO
                doc.addFileToVFS("calibri-bold.ttf", calibriBold);
                doc.addFont('calibri-bold.ttf', 'calibri-bold', 'bold');
                doc.setFont("calibri-bold","bold");
                doc.setFontSize(18);
                doc.setTextColor("#002060")
                doc.text("CONTROL GASTOS ADICIONALES", doc.internal.pageSize.getWidth() / 2, 15, null, 'center');
                //LINEA #1
                doc.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
                doc.setLineWidth(2.5);    
                doc.line(10, 18, 205, 18); // vertical line    
                //console.log(doc.internal.pageSize.getWidth())
                //obra,ubicación,ciudad,estado (TIPO DE LETRA BOLD)
                doc.setFont("calibri-bold","bold");
                doc.setFontSize(10);
                doc.setTextColor("black")
                doc.text("OBRA:", 70, 28, null, 'right');
                doc.text("UBICACIÓN:", 70, 33, null, 'right');
                doc.text("CIUDAD:", 70, 38, null, 'right');
                doc.text("ESTADO:", 70, 43, null, 'right');
                doc.text("FECHA:", 150, 45, null, 'right');
                doc.text("SEMANA:", 150, 49, null, 'right');
                //TIPO DE LETRA REGULAR
                doc.addFileToVFS("calibri-regular.ttf", calibriRegular);
                doc.addFont('calibri-regular.ttf', 'calibri-regular', 'normal');
                doc.setFont("calibri-regular","normal");
                doc.setFontSize(10);
                doc.text(obra.toUpperCase(), 75, 28, null, 'left');
                doc.text(direccion.toUpperCase(), 75, 33, null, 'left');
                doc.text("CHILPANCINGO", 75, 38, null, 'left');
                doc.text("GUERRERO", 75, 43, null, 'left');
                //FECHA DESCARGA
                doc.setFont("calibri-regular","normal");
                doc.text(fecha, 165, 45, null, 'center');
                //FECHA DEL REPORTE
                doc.setFont("calibri-regular","normal");
                doc.text(moment(ini).format("DD-MM-YYYY")+" - " + moment(fin).format("DD-MM-YYYY"), 175, 49, null, 'center');

                //LINEA #2
                doc.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
                doc.setLineWidth(1.0);    
                doc.line(10, 53, 205, 53); // vertical line  
                    
                //TABLA
                var rows = lista;
                //console.log(rows)
                //const last = rows[rows.length-1];
                //const totalSemana=last.totalSemana;
                let datos = []
                rows.forEach((element) => {
                    datos.push([element.nombreAdicional.toUpperCase(),
                    moment(element.fecha).format("DD-MM-YYYY"),
                    element.nombreUnidad.toUpperCase(),element.cantidad,
                    '$ '+formato(element.precio),
                    '$ '+formato(element.total)])
                });
                //console.log(datos)
                //TABLA
                autoTable(doc,
                    {head: [['CONCEPTO','FECHA', 'UNIDAD', 'CANTIDAD','PRECIO','SUBTOTAL']],
                    body:datos , tableWidth: 'wrap',
                    margin: {right:10, left:10 },
                    headStyles :{halign:'center',lineWidth:1,lineColor:"#1A2E4F"},
                    startY: 60,
                    theme:"plain",
                    columnStyles: {
                        0: {halign:"left",cellWidth: 40},
                        1: {halign:"center",cellWidth: 30},
                        2: {halign:"center",cellWidth: 30},
                        3: {halign:"center",cellWidth: 30},
                        4: {halign:"right",cellWidth: 30},
                        5: {halign:"right",cellWidth: 35},
                    }
                })
                startY=doc.lastAutoTable.finalY;
                //LINEA AL FINAL DE LA TABLA
                doc.setDrawColor("black", 0, 0); // draw red lines    
                doc.setLineWidth(1.0);    
                doc.line(10, startY, 205, startY); // vertical line  
                //TOTALES
                doc.setFont("calibri-bold","bold");
                doc.setFontSize(12);
                doc.setTextColor("black")
                doc.text("TOTAL", 160, startY+15); 
                doc.text("$ "+formato(totalSemana), 204, startY+15,"right");  
                //FOOTER//FOOTER
                const pageCountGeneral = doc.internal.getNumberOfPages();

                // For each page, print the page number and the total pages
                for(var j = 1; j <= pageCountGeneral; j++) {
                    //MARCA DE AGUA
                    var logoSemanal = new Image();
                    logoSemanal.src = watermark;
                    doc.addImage(logoSemanal, 'JPEG',32.945, 89.7,150,100);
                    // Go to page i
                    doc.setPage(j);
                    //Print Page 1 of 4 for example
                    doc.text('Página ' + String(j) + ' de ' + String(pageCountGeneral),210-20,300-30,null,null,"right");
                }

                /*doc.text("ROSMO",
                doc.internal.pageSize.getWidth() / 2 - (doc.getTextWidth('FOOTER') / 2),
                doc.internal.pageSize.getHeight() - 15,
                { baseline: 'top' });
                
                doc.setDrawColor("black", 0, 0); // draw red lines    
                doc.setLineWidth(1.0);    
                doc.line(10, startY, 205, startY); // vertical line */ 

                //var blob = doc.output("blob");
                //window.open(URL.createObjectURL(blob));
                doc.save('GASTOS ADICIONALES '+obra+' '+fechaDescarga+'.pdf');
            break;
            case 'general':
                //setRegistros([])
                //getRegistros(fechaSelect);
                //console.log(registros)
                //registros.length = 0 //limpiar lista
                var dateGeneral = moment( new Date());
                const fechaGeneral = dateGeneral.tz('America/Mexico_City').format('DD/MM/YYYY')

                //const fecha2 = date.tz('America/Mexico_City').format('DDMMYY')
                //console.log(fecha)
                var docGeneral = new jsPDF({format: 'letter',orientation:"portrait"});
                var company_logoGeneral = {
                    w: 30,
                    h: 20
                };

                var startYGeneral=0;
                //IMAGEN
                var imgDataGeneral ="https://www.app-system.rosmocoin.com/rosmo-img/rosmo-logo-v2.png"
                docGeneral.addImage(imgDataGeneral,'JPEG',10,25,company_logoGeneral.w,company_logoGeneral.h);
                //console.log(doc.internal.pageSize.getHeight())
               
                //TITULO
                docGeneral.addFileToVFS("calibri-bold.ttf", calibriBold);
                docGeneral.addFont('calibri-bold.ttf', 'calibri-bold', 'bold');
                docGeneral.setFont("calibri-bold","bold");
                docGeneral.setFontSize(18);
                docGeneral.setTextColor("#002060")
                docGeneral.text("CONTROL GASTOS ADICIONALES", docGeneral.internal.pageSize.getWidth() / 2, 15, null, 'center');
                //LINEA #1
                docGeneral.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
                docGeneral.setLineWidth(2.5);    
                docGeneral.line(10, 18, 205, 18); // vertical line    
                //console.log(doc.internal.pageSize.getWidth())
                //obra,ubicación,ciudad,estado (TIPO DE LETRA BOLD)
                docGeneral.setFont("calibri-bold","bold");
                docGeneral.setFontSize(10);
                docGeneral.setTextColor("black")
                docGeneral.text("OBRA:", 70, 28, null, 'right');
                docGeneral.text("UBICACIÓN:", 70, 33, null, 'right');
                docGeneral.text("CIUDAD:", 70, 38, null, 'right');
                docGeneral.text("ESTADO:", 70, 43, null, 'right');
                docGeneral.text("FECHA:", 150, 45, null, 'right');
                //TIPO DE LETRA REGULAR
                docGeneral.addFileToVFS("calibri-regular.ttf", calibriRegular);
                docGeneral.addFont('calibri-regular.ttf', 'calibri-regular', 'normal');
                docGeneral.setFont("calibri-regular","normal");
                docGeneral.setFontSize(10);
                docGeneral.text(obra.toUpperCase(), 75, 28, null, 'left');
                docGeneral.text(direccion.toUpperCase(), 75, 33, null, 'left');
                docGeneral.text("CHILPANCINGO", 75, 38, null, 'left');
                docGeneral.text("GUERRERO", 75, 43, null, 'left');
                //FECHA DESCARGA
                docGeneral.setFont("calibri-regular","normal");
                docGeneral.text(fechaGeneral, 165, 45, null, 'center');
                //LINEA #2
                docGeneral.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
                docGeneral.setLineWidth(1.0);    
                docGeneral.line(10, 53, 205, 53); // vertical line  
                    
                //TABLA
                var rowsGeneral = lista;
                //console.log(rows)
                //const last = rows[rows.length-1];
                //const totalSemana=last.totalSemana;
                let datosGeneral = []
                rowsGeneral.forEach((element) => {
                    datosGeneral.push([element.nombreAdicional.toUpperCase(),
                    element.nombreUnidad.toUpperCase(),moment(element.fecha).format("DD-MM-YYYY"),element.cantidad,
                    '$ '+formato(element.precio),
                    '$ '+formato(element.total)])
                });
                
                //TABLA
                autoTable(docGeneral,
                    {head: [['CONCEPTO', 'UNIDAD','FECHA', 'CANTIDAD','PRECIO','SUBTOTAL']],
                    body:datosGeneral , tableWidth: 'wrap',
                    margin: {right:10, left:10 },
                    headStyles :{halign:'center',lineWidth:1,lineColor:"#1A2E4F"},
                    startY: 60,
                    theme:"plain",
                    columnStyles: {
                        0: {halign:"left",cellWidth: 40},
                        1: {halign:"center",cellWidth: 30},
                        2: {halign:"center",cellWidth: 30},
                        3: {halign:"center",cellWidth: 25},
                        4: {halign:"right",cellWidth: 30},
                        5: {halign:"right",cellWidth: 40}
                    }
                })
                startYGeneral=docGeneral.lastAutoTable.finalY;
                //LINEA AL FINAL DE LA TABLA
                docGeneral.setDrawColor("black", 0, 0); // draw red lines    
                docGeneral.setLineWidth(1.0);    
                docGeneral.line(10, startYGeneral, 205, startYGeneral); // vertical line  
                //TOTALES
                docGeneral.setFont("calibri-bold","bold");
                docGeneral.setFontSize(12);
                docGeneral.setTextColor("black")
                docGeneral.text("TOTAL", 160, startYGeneral+15); 
                docGeneral.text("$ "+formato(totalSemana), 204, startYGeneral+15,"right");  
                //FOOTER//FOOTER
                const pageCount = docGeneral.internal.getNumberOfPages();

                // For each page, print the page number and the total pages
                for(var i = 1; i <= pageCount; i++) {
                    //MARCA DE AGUA
                    var logoGeneral = new Image();
                    logoGeneral.src = watermark;
                    docGeneral.addImage(logoGeneral, 'JPEG',32.945, 89.7,150,100);
                    // Go to page i
                    docGeneral.setPage(i);
                    //Print Page 1 of 4 for example
                    docGeneral.text('Página ' + String(i) + ' de ' + String(pageCount),210-20,300-30,null,null,"right");
                }

                /*doc.text("ROSMO",
                doc.internal.pageSize.getWidth() / 2 - (doc.getTextWidth('FOOTER') / 2),
                doc.internal.pageSize.getHeight() - 15,
                { baseline: 'top' });*/

                //var blobGeneral = docGeneral.output("blob");
                //window.open(URL.createObjectURL(blobGeneral));
                docGeneral.save('GASTOS ADICIONALES GENERAL -'+obra+'.pdf');
            break;
            default:
                console.log(`ERROR`);
        }
        handleCloseDescarg();
    }

    return(
        <div className="materiales">
            {
                isLoading === true ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">CONTROL DE GASTOS ADICIONALES DE OBRA</label>
                    </div>
                    <div >
                        <div>
                            <label className='text-uppercase'><strong>NOMBRE DE LA OBRA:</strong> {obra}</label>
                        </div>
                        <div>
                            <label className='text-uppercase'><strong>DUEÑO:</strong> {cliente}</label>
                        </div>
                    </div>
                    <div className='divboton mb-2' style={{margin:'5px 0'}}>                                                                                             
                        <div className='boton' style={{display:'flex', justifyContent:'space-between'}} >
                            <button title='Agregar Area' onClick={handleShowAdicional} style={{justifyContent:'center'}} className="btn btn-light btncolor" type="button">
                                <label className="agregar">REGISTRAR GASTO</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <button title='DESCARGAR'  onClick={handleShowPdf}  style={{justifyContent:'center'}} className="btn btn-light btncolor" type="button">
                                <BsFiletypePdf style={{fontSize:'25px'}}/> <label className="agregar">DESCARGAR</label>
                            </button>
                            <input className="form-control" value={busqueda} onChange={buscar} style={{width:'50%'}} type="search" placeholder="Buscar" aria-label="Search"/>
                        </div>
                    </div>
                    <div className='divboton mb-2' style={{textAlign:'right'}}>
                        <div>
                            <strong><h5>{adiTotal === 'NaN' ? ("TOTAL: $"+0):"TOTAL: $"+adiTotal }</h5></strong>
                        </div>
                    </div>
                    { gastos.length === 0 ? (<h3 style={{marginTop:'30vh'}}>NO HAY REGISTROS</h3>):(
                        <div className="caja-asistencia"  >
                            <div className="table tabla">
                                <table className="table text-uppercase">
                                    <thead >
                                        <tr >
                                            <th>CONCEPTO</th>
                                            <th>CANTIDAD</th>
                                            <th>UNIDAD</th>
                                            <th>PRECIO</th>
                                            <th>TOTAL</th>
                                            <th>FECHA</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        {gastos.map(g =>{
                                            return(
                                                <tr key={g.idGasto}>
                                                    <td>{g.nombreAdicional}</td>
                                                    <td>{g.cantidad}</td>
                                                    <td>{g.nombreUnidad}</td>
                                                    <td>$ {formato(g.precio)}</td>
                                                    <td>$ {formato(g.total)}</td>
                                                    <td>{moment(g.fecha).format("DD-MM-YYYY")}</td>
                                                </tr>                             
                                            )
                                        })}                        
                                    </tbody>
                                </table>
                            </div>           
                        </div>
                    )}

                    {/*PDF*/}
                    <Modal  show={showPdf}  onHide={handleClosePdf} >
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>DESCARGAR PDF</Modal.Title>
                            <CloseButton onClick={handleClosePdf} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form >
                            <Modal.Body  style={{textAlign:'left', marginTop:'15px'}}>
                                <div className="mb-3">
                                    <div className="form-check">
                                        <input type="radio" className="form-check-input" onChange={tipoPdf} name="tipoPDF" value="general" id="medium" />
                                        <label className="form-check-label">GENERAL</label>
                                    </div> 
                                </div>
                                <div className="mb-3">
                                    <div className="form-check">
                                        <input type="radio" name="tipoPDF" className="form-check-input" onChange={tipoPdf} value="semana" id="regular" />
                                        <label className="form-check-label">SELECCIONE UNA FECHA</label>
                                    </div> 
                                    {
                                        typePdf==="semana"?(
                                            <div className="mb-3">
                                                <input type="date" className="form-control" onChange={(e)=>setFecha(e.target.value)}  id="exampleFormControlInput1" required/>
                                            </div>
                                        )
                                        :(null)
                                    }
                                </div> 
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleClosePdf}>CANCELAR</Button>                                               
                                <Button type="button" className="btn btn-light btncolor" onClick={()=> getRegistros(fechaSelect)} >DESCARGAR</Button>                                                     
                            </Modal.Footer>
                        </form>
                    </Modal>  

                    {/*AGREGAR GASTO ADICIONAL*/}     
                    <Modal  show={showGasAdic}  onHide={handleCloseAdicional}  id="modal-agregar-adicional" backdrop="static" keyboard={false}>
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR ADICIONAL</Modal.Title>
                            <CloseButton onClick={handleCloseAdicional} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <Modal.Body  style={{textAlign:'left',height:'60vh', overflowY:"scroll" }}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <div className="mb-3" style={{textAlign:'center'}}>
                                <h5 className="modal-title text-uppercase " id="exampleModalLabel">{obra}</h5>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">CONCEPTO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <select className="form-control" required 
                                    onChange={e => setConcepto(e.target.value) }   >
                                    <option >--Seleccione una opción--</option>
                                    {adicionales.map(a => {
                                        return(
                                            <option key={a.idAdicional} value={a.idAdicional}>{a.nombreAdicional}</option>
                                        )
                                    })
                                    }
                                </select>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="text-uppercase" > unidad <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <Select
                                    classNamePrefix="select"
                                    placeholder="Seleccionar unidad..."
                                    defaultValue={unidades[0]}
                                    required
                                    options={unidades.map(tip=>({label:tip.nombreUnidad,value:tip.idUnidad}))}
                                    onChange={handleSelectChange}
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">CANTIDAD <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="number" step="any" min={0} className="form-control"  id="exampleFormControlInput1" required
                                onChange={e => setCantidad(e.target.value) }/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">PRECIO <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="number"  min={0} className="form-control"  id="exampleFormControlInput2" step="any" required
                                onChange={e => setPrecio(e.target.value) }/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput1" className="form-label">FECHA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                <input type="date" className="form-control" max={getFecha()} id="exampleFormControlInput1" required
                                onChange={e => setFechaAd(e.target.value) }/>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type="button" className="btn btn-secondary"  onClick={handleCloseAdicional} >CANCELAR</Button>
                            {concepto === undefined | concepto === '' | 
                            idUnidad === undefined | idUnidad === '' | 
                            cantidad === undefined | cantidad === '' | 
                            precio === undefined | precio === '' |
                            fecha === undefined | fecha === '' ? (
                                <button type="button" className="btn btncolor" onClick={validar} >ACEPTAR</button>
                            ):(
                                isSaving===true?
                                <Button className="btn btn-primary" type="button" disabled >
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...
                                </Button>:
                                <Button type="button" className="btn btn-light btncolor" onClick={confirmar} >ACEPTAR</Button>                                                     
                            )}                                                  
                        </Modal.Footer>
                    </Modal>  

                    {/*DESCARGANDO....*/}
                    <Modal  show={showDescargar}  onHide={handleCloseDescarg} centered >
                        <Modal.Body  style={{textAlign:'center', marginTop:'15px',marginBottom:"5%"}}>
                            <div>
                                <h3>DESCARGANDO</h3>
                            </div>
                            <div style={{textAlign:'center', marginTop:'15px'}}>
                                <PropagateLoader color="#1A2E4F" />
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            }
        </div>
    )
}

export default GastosAdicionalesObra;